import React from 'react'
import _ from "lodash";
import {COLOR_LIST} from "../../../../common/constants/color.constant";
import {TrashIcon} from "@heroicons/react/24/solid";
import ClearButton from "../../../../common/ui/clear-button";
import RenderFields from "../../../../common/ui/render-fields";
import {COLOR_FIELD_LIST, RECTANGLE_FIELD_LIST} from "../../../constants/design.constant";
import SelectGradientColorDetails from "./select-gradient-color-details";

const colorList = _.orderBy(COLOR_LIST, 'colorKey');

const SelectColorCodeDetails = ({
                                    parentForm,
                                    colorAttribute,
                                    colorKeyAttribute,
                                    colorCodeKeyAttribute,
                                    handleColorDetailsChanges,
                                    handleClearColorDetailsChanges,
                                }) => {
    const colorMap = _.keyBy(COLOR_LIST, 'colorKey');

    const handleClearColor = () => {
        const attributeList = [colorKeyAttribute, colorCodeKeyAttribute, colorAttribute];
        handleClearColorDetailsChanges(attributeList, parentForm);
    }

    return (
        <>

            <div className="flex justify-start move-up-10">
                <div className="field-group-container">
                    <div className="field-container">
                        <select
                            className="input-field"
                            id={colorKeyAttribute}
                            name={colorKeyAttribute}
                            value={parentForm[colorKeyAttribute]}
                            onChange={(event) => {
                                handleColorDetailsChanges(event, parentForm);
                            }}>
                            <option value="">Choose Color</option>
                            {colorList?.map((colorDetail, index) => (
                                <option key={index}
                                        value={colorDetail.colorKey}>{colorDetail.colorName}</option>
                            ))}
                        </select>
                    </div>
                    <div className="field-container">
                        <select
                            className="input-field w-24"
                            id={colorCodeKeyAttribute}
                            name={colorCodeKeyAttribute}
                            value={parentForm[colorCodeKeyAttribute]}
                            onChange={(event) => {
                                handleColorDetailsChanges(event, parentForm);
                            }}>
                            <option value="">Choose Shade</option>
                            {colorMap[parentForm[colorKeyAttribute]]?.colorCodes.map((colorCodeDetail, index) => (
                                <option key={index}
                                        value={colorCodeDetail.colorCodeKey}>{colorCodeDetail.colorCodeName}</option>
                            ))}
                        </select>
                    </div>

                    <ClearButton handleClear={handleClearColor}/>
                </div>
            </div>

        </>
    )
}

export default SelectColorCodeDetails
